import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { TableDataModel } from 'src/app/shared/models/CommandCenterUI/TableDataModel.model';
import { GenericLabelValue } from 'src/app/shared/models/DTO/GenericLabelValue.dto';
import { EmployeeRecord } from 'src/app/shared/models/EmployeeRecord.model';
import { Job } from 'src/app/shared/models/focusDataModels/Job';

@Component({
	selector: 'app-employee-list',
	templateUrl: './employee-list.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class EmployeeListComponent implements OnInit, OnDestroy, OnChanges {
	employeeList: EmployeeRecord[];

	jobList: Job[];
	loadComplete: boolean = false;

	subscriptions: Subscription = new Subscription();

	tableModel: TableDataModel = new TableDataModel();

	statusList: GenericLabelValue[] = [
		{
			label: `Active`,
			value: ['fas', 'circle'],
			faIconClass: 'fas',
			meta: 'circle',
		},
		{
			label: `Inactive`,
			value: ['fad', 'circle'],
			faIconClass: 'fad',
			meta: 'circle',
		},
		{
			label: `Terminated`,
			value: ['far', 'circle'],
			faIconClass: 'far',
			meta: 'circle',
		},
	];

	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService, private router: Router) {}
	ngOnChanges(changes: SimpleChanges): void {
		console.log(changes);
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}

	ngOnInit(): void {
		this.app.loading(true);
		this.subscriptions.add(
			this.venueService.employeeList.subscribe((data) => {
				this.employeeList = [...data];
				this.employeeList.forEach((ee) => {
					ee.jobs?.length > 0 && (ee.job1 = ee.jobs[0].name);
					switch (ee.status) {
						case EmployeeStatus.ACTIVE:
							ee.statusIcon = ['fas', 'circle'];
							break;
						case EmployeeStatus.INACTIVE:
							ee.statusIcon = ['fad', 'circle'];
							break;
						case EmployeeStatus.TERMINATED:
							ee.statusIcon = ['far', 'circle'];
							break;
					}
				});
			})
		);

		this.subscriptions.add(
			this.venueService.jobList.subscribe((data) => {
				if (data.length > 0) {
					this.jobList = [...data];
					this.buildTableDataModel();
				}
			})
		);

		if (this.venueService.jobList.value.length === 0) {
			this.venueService.jobListGet(this.venueService.subscriptionVenue.value.key);
		}

		this.venueService.employeeListGet(this.venueService.subscriptionVenue.value.key);
		this.getTableDataModel();
	}

	async buildTableDataModel() {
		this.tableModel.columns.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1));
		let jobColumn = this.tableModel?.columns.find((i) => i.filterSelectArray === 'jobList');
		if (jobColumn && this.jobList) {
			jobColumn.filterSelectArray = this.jobList.map((i) => {
				return new GenericLabelValue({
					label: i.name,
					value: i.name,
				});
			});

			let statusColumn = this.tableModel?.columns.find((i) => i.filterSelectArray === 'statusList');
			statusColumn && (statusColumn.filterSelectArray = this.statusList);

			this.loadComplete = true;
			this.app.loading(false);
		}
	}

	async getTableDataModel() {
		const resp = await this.focuslink.adminCommandCenterTableModel('employee');
		this.tableModel = new TableDataModel(resp);
		this.buildTableDataModel();
	}

	rowSelect(record: EmployeeRecord) {
		this.router.navigate([`cc/employees/${record.id}`]);
	}
}

export enum EmployeeStatus {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	TERMINATED = 'terminated',
}
